import { toAbsoluteUrl } from '@/_metronic/helpers';
import { mapAxiosErrorToFriendlyMessage } from '@/api/core/axiosErrorMapper';

type ErrorStateProps = {
  error: unknown;
  /** Renders the retry action when provided (query refetch or boundary reset). */
  onRetry?: () => void;
};

/**
 * Standard failure state: Metronic error illustration plus the friendly pt-BR
 * title/message already derived from the error by the axios mapper. Used both
 * as the ErrorBoundary fallback and directly by pages handling `isError`.
 */
const ErrorState = ({ error, onRetry }: ErrorStateProps) => {
  const { title, message, code } = mapAxiosErrorToFriendlyMessage(error);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center py-15">
      <div className="mb-8">
        <img alt="" className="mw-100 mh-250px theme-light-show" src={toAbsoluteUrl('media/auth/500-error.png')} />
        <img alt="" className="mw-100 mh-250px theme-dark-show" src={toAbsoluteUrl('media/auth/500-error-dark.png')} />
      </div>

      <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">{title || 'Algo deu errado'}</h1>

      <div className="fw-semibold fs-6 text-gray-500 mb-7" style={{ maxWidth: 500 }}>
        {message}
      </div>

      {onRetry ? (
        <button className="btn btn-sm btn-primary" type="button" onClick={onRetry}>
          <i className="ki-duotone ki-arrows-circle fs-4 me-1">
            <span className="path1" />
            <span className="path2" />
          </i>
          Tentar novamente
        </button>
      ) : null}

      {code && code !== 'UNKNOWN_ERROR' ? <div className="text-gray-500 fs-8 mt-6">código {code}</div> : null}
    </div>
  );
};

export default ErrorState;
